/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Pause_While_TypingInputs */



/**
* | output |
* | --- |
* | "Pause While Typing" |
*
* @param {Options_Editor_Pause_While_TypingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_pause_while_typing = /** @type {((inputs?: Options_Editor_Pause_While_TypingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Pause_While_TypingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre en pause pendant la saisie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Pause beim Tippen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pausa durante la digitazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пауза во время набора текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pausa mientras escribes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打字时暂停")
	if (locale === "ja") return /** @type {LocalizedString} */ ("入力中に一時停止する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइप करते समय विराम दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faça uma pausa enquanto digita.")
	return /** @type {LocalizedString} */ ("Pause While Typing")
});